import React from 'react';
import { motion } from 'framer-motion';

function Vision2035() {
  return (
    <section id="vision-2035" className="py-20 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      {/* subtle decorative blobs */}
      <div className="pointer-events-none absolute -top-16 -left-16 w-56 h-56 bg-[rgb(130,88,18)]/10 rounded-full blur-3xl" aria-hidden="true"></div>
      <div className="pointer-events-none absolute -bottom-20 -right-24 w-72 h-72 bg-[rgb(130,88,18)]/10 rounded-full blur-3xl" aria-hidden="true"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Our 2035 Vision</h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            By 2035, Intellectual Oasis Fellowship will operate a data‑rich research repository and collaborative hub that influences policy and improves educational systems across Nigeria, West Africa, and Africa.
          </p>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          variants={{
            hidden: { opacity: 0 },
            show: {
              opacity: 1,
              transition: { staggerChildren: 0.12 }
            }
          }}
          className="grid gap-6 sm:gap-8 grid-cols-1 md:grid-cols-3"
        >
          {[{
            title: 'Open Data Repository',
            desc: 'Curated, anonymized datasets on learning outcomes, equity, and school systems.'
          },{
            title: 'Policy & Practice',
            desc: 'Timely briefs and implementation guides for ministries, schools, and NGOs.'
          },{
            title: 'Regional Collaboration',
            desc: 'A fellowship network co‑authoring research across countries and contexts.'
          }].map((card, idx) => (
            <motion.div
              key={idx}
              variants={{
                hidden: { opacity: 0, y: 20 },
                show: { opacity: 1, y: 0 }
              }}
              transition={{ duration: 0.5, delay: idx * 0.05 }}
              whileHover={{ y: -4, scale: 1.01 }}
              whileTap={{ scale: 0.99 }}
              className="bg-white rounded-2xl border border-gray-100 p-6 sm:p-8 shadow-sm hover:shadow-xl transition-all duration-300"
            >
              <div className="w-10 h-10 rounded-md bg-[rgb(130,88,18)]/10 text-[rgb(130,88,18)] flex items-center justify-center mb-3">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{card.title}</h3>
              <p className="text-gray-600">{card.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default Vision2035;


